import { Keys } from "common/const/keys";
import { GlobalKeyListener } from "common/utils/globalKeyListener";
import React from "react";

export const CloseButton = ({ size = 12, color = "#000", onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      style={{ flexShrink: 0, cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}>
      <path d="M13 1L1 13M1 1L13 13" stroke={color} strokeWidth="1" />
      <GlobalKeyListener
        triggerKeys={[Keys.Escape]}
        onTrigger={onClick}
        enabled={true}
      />
    </svg>
  );
};

export const CloseIcon = ({ size = 12, color = "#000", onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      style={{ flexShrink: 0, cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}>
      <path d="M13 1L1 13M1 1L13 13" stroke={color} strokeWidth="1" />
    </svg>
  );
};
